module.exports = "/images/Cosmic Golf.svg?032ae2dc71d52677eb8a298b34939bf5";